module.exports = __webpack_public_path__ + "static/corporate-staff-transport-sm-730d0d76fe743660a022ebaebcfd2934.webp";